import React from "react";
import LoginForm from "b2b/components/LoginForm";

function LoginFormExample() {
  return (
    <>
      <h1>&lt;LoginForm&gt;</h1>
      <LoginForm />
    </>
  );
}

export default React.memo(LoginFormExample);
